export type CandidateStatus = 'applied' | 'screening' | 'interview' | 'technical' | 'offer' | 'hired' | 'rejected';

export type CandidateExperience = 'entry' | 'junior' | 'mid' | 'senior' | 'lead' | 'executive';

export interface Candidate {
  id: number;
  name: string;
  email: string;
  phone: string;
  position: string;
  department: string;
  experience: CandidateExperience;
  status: CandidateStatus;
  appliedDate: string;
  resume: string;
  skills: string[];
  rating: number;
  salary?: number;
  notes?: string;
  avatar?: string;
  location: string;
  source: string;
}

export interface CandidateFilters {
  search: string;
  status: CandidateStatus[];
  experience: CandidateExperience[];
  department: string[];
  dateRange: {
    start: string | null;
    end: string | null;
  };
}

export const initialFilters: CandidateFilters = {
  search: '',
  status: [],
  experience: [],
  department: [],
  dateRange: {
    start: null,
    end: null,
  },
};

export const statusColors: Record<CandidateStatus, string> = {
  applied: '#3b82f6', // blue
  screening: '#8b5cf6', // purple
  interview: '#f59e0b', // amber
  technical: '#6366f1', // indigo
  offer: '#10b981', // emerald
  hired: '#059669', // green
  rejected: '#ef4444', // red
};

export const experienceLabels: Record<CandidateExperience, string> = {
  entry: 'Entry Level (0-1 years)',
  junior: 'Junior (1-3 years)',
  mid: 'Mid-Level (3-5 years)',
  senior: 'Senior (5-8 years)',
  lead: 'Lead (8-12 years)',
  executive: 'Executive (12+ years)',
};

export const experienceOrder: Record<CandidateExperience, number> = {
  entry: 1,
  junior: 2,
  mid: 3,
  senior: 4,
  lead: 5,
  executive: 6,
};